import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService } from '@eforall/dashboard';
import { LanguageId } from '@interfaces';
import { AppService } from '../../../../../services';
import { PersonDialog } from '../../../person-dialog';
import { MentorSignUpViewerDialogDataService } from '../mentor-sign-up-viewer-dialog-data.service';

@Component({
	selector: 'mentor-sign-up-details-part',
	standalone: true,
	templateUrl: './details.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './details.part.scss'
})
export class MentorSignUpDetailsPart {

	private readonly dialogDataService = inject(MentorSignUpViewerDialogDataService);
	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly dialog = inject(DialogService);

	public readonly mentorSignUpDetails = computed(() => {
		const details = this.dialogDataService.mentorSignUpDetails();

		if (!details) return undefined;
		return {
			...details,
			trimesterName: this.app.getTrimesterNameById(details.trimesterId),
			formattedCreatedUTC: this.util.date.formatUTC(details.createdUTC!, 'MM/DD/YYYY', 'No Time', 'en-US'),
			approvedLanguages: (details.canVolunteerInEnglish && details.canVolunteerInSpanish) ? 'English and Spanish' : (details.canVolunteerInEnglish) ? 'English' : (details.canVolunteerInSpanish) ? 'Spanish' : 'None',
			assignedLanguageId: details.assignedLanguageId === LanguageId.English ? 'English' : details.assignedLanguageId === LanguageId.Espanol ? 'Spanish' : 'Not Assigned Yet',
			selectedLanguage: details.selectedLanguage === "EN" ? 'English' : details.selectedLanguage === "ES" ? 'Spanish' : 'Open to English or Spanish',
		}
	});

	public async openPersonDialog(personId: number) {
		await this.dialog.showCustom(PersonDialog, { data: { personId, toEdit: false } }, 800, 800);
	}

}